import React, { Component } from 'react'

export class ImageCredits extends Component {
  links = [
    {
      name: 'Freepik',
      href: 'https://www.freepik.com/',
    },
    {
      name: 'Pexels',
      href: 'https://www.pexels.com/',
    },
    {
      name: 'Pixabay',
      href: 'https://pixabay.com/',
    },
    {
      name: 'Shutterstock',
      href: 'https://www.shutterstock.com/',
    },
  ]

  renderItem = ({ name, href }, index) => (
    <li key={index}>
      <a href={href}>{name}</a>
    </li>
  )

  renderItems = () => this.links.map(this.renderItem)

  render() {
    return (
      <div>
        <h6>Images</h6>
        <ul>{this.renderItems()}</ul>
      </div>
    )
  }
}

export default ImageCredits
